<script setup></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5269 7.99976C14.5269 11.6046 11.6046 14.5269 7.99976 14.5269C4.39494 14.5269 1.47266 11.6046 1.47266 7.99976C1.47266 4.39494 4.39494 1.47266 7.99976 1.47266C11.6046 1.47266 14.5269 4.39494 14.5269 7.99976ZM10.7608 6.54566C10.9519 6.34629 10.9452 6.02978 10.7458 5.83871C10.5464 5.64765 10.2299 5.65438 10.0389 5.85375L6.94985 9.07707L5.96085 8.04506C5.76978 7.84569 5.45327 7.83895 5.2539 8.03002C5.05453 8.22108 5.0478 8.53759 5.23886 8.73696L6.58886 10.1457C6.68317 10.2441 6.81356 10.2997 6.94985 10.2997C7.08615 10.2997 7.21654 10.2441 7.31085 10.1457L10.7608 6.54566Z"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
